import { createEnvelopeSource } from './create-envelope-source';

/**
 * Age distribution of accounts created in the selected period
 * (`GET /analytics/demographics/age-brackets`): the `accounts` cohort scalar
 * plus the seven-bracket `ageBracket` axis, Unknown last. Total-only, like
 * `app-downloads-total`: the endpoint has no daily series and no compare arm.
 */
export const ageBracketsSource = createEnvelopeSource({
    label: 'Age brackets',
    endpoint: 'analytics/demographics/age-brackets',
    metrics: [{ id: 'accounts', label: 'Accounts', type: 'scalar' }],
    forms: ['bars'],
    regionGrain: 'province',
});
